import {React,useEffect, useState} from "react";
import { useReducer } from "react";
import Confirm from "./Confirm"
import { reducer,initialState } from "../reducers/reducers";
import Popup from "./Popup";
import Table1 from "./Table1";
import Button from "./Button";
import EditText from "./EditText";
import Dropdown from "./Dropdown";
import EditQuantity from "./EditQuantity";
import API_URLS from "../Urls";
import DropdownSearch from "./DropdownSearch";
import { useAuth } from "./AuthProvider";

const ViewClaim = ({claimData, onClose}) => {
  const { canRead, canWrite } = useAuth();
  const [objects,setObjects] = useState()
  const [tipoToIndexMap, setTipoToIndexMap] = useState({});
  const [updatedDrone,setUpdatedDrone] = useState(false)
  const [newObjectsToPost,setNewObjectsToPost] = useState([]) //this will store any objects to be posted
  const [updatedObjects,setUpdatedObjects] = useState([]) //objects to put
  const [clientData,setClientData] = useState({})
  const [extraObjects,setExtraObjects] = useState()
  const [itemsToAdd,setItemsToAdd] = useState([]) //this will tell the program what items need to be updated or posted. doesnt store their information.
  const [accesories,setAccesories] = useState([]) //stores the fetched accesories for each dropdown
  const [objectsToDelete,setObjectsToDelete] = useState([]) //stores the ids of the objects to be deleted from the claimobjects table
  const [extraAccesories,setExtraAccesories] = useState([])
  const [fetchedTipos, setFetchedTipos] = useState(new Set());
  const [newExtraObjects,setNewExtraObjects] = useState([])
  const [itemsToEdit,setItemsToEdit] = useState([])
  const tipos = ['Helices','Bateria','Control']
const createNewObjectToPost = (tipo) => {
  const newItem = { tipo, cantidad: 1, modelo: '', no_serie: '', observaciones: '' };
  let index;
  setNewObjectsToPost(prev => {
    const updated = [...prev, newItem];
    index = updated.length - 1;
    return updated;
  });
  return index;
};


// Función para generar el folio
const generateFolio = (clientId, fechaNota, sucursal) => {
  let fechaFormateada = "000000";
  let id_sucursal = "NR"; // DATO X
  if (fechaNota) {
    const parts = fechaNota.split('-');
    if (parts.length === 3) {
      const [year, day, month] = parts;
      fechaFormateada = `${month}${day}${year}`;
    }
  }
  if (sucursal == 'Aguascalientes'){
    id_sucursal = 'CA'
  } else {
    id_sucursal = 'CZ'
  }
  return `${id_sucursal}${clientId}${fechaFormateada}`;
};

function downloadNotePDF(id, fechaNota, clienteID){
  fetch(API_URLS.PRINT_NOTA + '?id=' + id, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/pdf',
    },
  })
  .then((response) => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.blob(); // Convert the response to a Blob
  })
  .then((blob) => {
    const pdfBlob = new Blob([blob], {type: 'application/pdf'});
    const url = window.URL.createObjectURL(pdfBlob);
    
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${generateFolio(clienteID, fechaNota)}.pdf`);
    
    document.body.appendChild(link);
    link.click();
    
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}
const updateNewObjectField = (index, field, value) => {
  setNewObjectsToPost(prev => {
    const updated = [...prev];
    updated[index] = { ...updated[index], [field]: value };
    return updated;
  });
};
 const handleAddClick = (tipo) => {
  if (!itemsToAdd.includes(tipo)) {
    const index = newObjectsToPost.length;
    const newItem = { tipo, cantidad: 1, modelo: '', no_serie: '', observaciones: '' };
    setNewObjectsToPost(prev => [...prev, newItem]);
    setTipoToIndexMap(prev => ({ ...prev, [tipo]: index }));
    setItemsToAdd(prev => [...prev, tipo]);
    

  }
  console.log(itemsToAdd)
};

  const updateNewExtraObject = (index, field, value) => {
    setNewExtraObjects((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        [field]: value,
      };
      return updated;
    });
  };
  const ensureItemInUpdatedObjects = (item) => {
  setUpdatedObjects(prev => {
    const exists = prev.some(obj => obj.id === item.id);
    return exists ? prev : [...prev, item];
  });
};
  const postData = (url, dataToSend, onSuccesful) => {
        // Verificar si el usuario tiene permisos de escritura
        if (!canWrite('acceso_notas_recepcion')) {
            console.error('No tienes permisos para crear datos');
            alert('No tienes permisos para crear datos');
            return Promise.reject('No tienes permisos para crear datos');
        }
        
        console.log("Posting to URL:", url); // Check URL during each post
        console.log("Data to send:", dataToSend);

        return fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dataToSend)
        })
        .then(response => {
            if (!response.ok) throw new Error('Network response was not ok ' + response.statusText);
            return response.json();
        })
        .then(data => {
            if (typeof onSuccesful === 'function') onSuccesful(data);
            console.log(data);
            return data;
        })
        .catch(error => {
            console.error('There was a problem with the fetch operation:', error);
            throw error;
        });
    };
  
  const putData = (url, dataToSend, onSuccesful) => {
        // Verificar si el usuario tiene permisos de escritura
        if (!canWrite('acceso_notas_recepcion')) {
            console.error('No tienes permisos para modificar datos');
            alert('No tienes permisos para modificar datos');
            return Promise.reject('No tienes permisos para modificar datos');
        }
        
        console.log("Posting to URL:", url); // Check URL during each post
        console.log("Data to send:", dataToSend);

        return fetch(url, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dataToSend)
        })
        .then(response => {
            if (!response.ok) throw new Error('Network response was not ok ' + response.statusText);
            return response.json();
        })
        .then(data => {
            if (typeof onSuccesful === 'function') onSuccesful(data);
            console.log(data);
            return data;
        })
        .catch(error => {
            console.error('There was a problem with the fetch operation:', error);
            throw error;
        });
    };  
    const deleteData =(url,onSuccesful)=>{
        // Verificar si el usuario tiene permisos de escritura
        if (!canWrite('acceso_notas_recepcion')) {
            console.error('No tienes permisos para eliminar datos');
            alert('No tienes permisos para eliminar datos');
            return Promise.reject('No tienes permisos para eliminar datos');
        }
        
        console.log(url)
        return fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            }})
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }
            return response.json();
        })
        .then(data => {
          console.log(data)
          if (typeof onSuccesful === 'function') onSuccesful(data);
          return data;
        })
        .catch(error => {
          console.error('There was a problem with the fetch operation:', error);
          throw error;
        });}
  const fetchData =(url,onSuccesful)=>{
        // Verificar si el usuario tiene permisos de lectura
        if (!canRead('acceso_notas_recepcion')) {
            console.error('No tienes permisos para ver estos datos');
            alert('No tienes permisos para ver estos datos');
            return Promise.reject('No tienes permisos para ver estos datos');
        }
        
        console.log(url)
        return fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }})
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }
            return response.json();
        })
        .then(data => {
          console.log(data)
          if (typeof onSuccesful === 'function') onSuccesful(data);
          return data;
        })
        .catch(error => {
          console.error('There was a problem with the fetch operation:', error);
          throw error;
        });}
useEffect(() => {
  console.log(claimData);
  fetchData(API_URLS.CLIENTS+"?id="+claimData.cliente,(data)=>setClientData(data[0]))
  fetchObjects()
}, [claimData]);
const fetchObjects = ()=>{
  setItemsToAdd([])
  setUpdatedDrone(false)
  setNewExtraObjects([])
  setNewObjectsToPost([])
  setObjectsToDelete([])
  setUpdatedObjects([])
  fetchData(API_URLS.CLAIMOBJECT + '?id=' + claimData.id, (baseData) => {
    const fetchPromises = baseData.map(item =>
      new Promise((resolve) => {
        let url = "";
        switch (item.tipo) {
          case 'Dron Enterprise':
          case 'Dron Comercial':
            url = API_URLS.DRONES;
            break;
          case 'Parte':
            url = API_URLS.PARTS;
            break;
          case 'Accesorio':
          case 'Accesorios':
            url = API_URLS.ACCESORIES;
            break;
          default:
            console.warn(`Unknown tipo: ${item.tipo}, skipping`);
            return resolve(null); // skip this item
        }

        fetchData(url + '?id=' + item.objectid, (detailData) => {
          if (!detailData || detailData.length === 0) {
            console.warn(`No data found for objectid=${item.objectid}`);
            return resolve(null);
          }

          const { tipo: _, ...itemWithoutTipo } = item;
          resolve({
            ...detailData[0],
            ...itemWithoutTipo,
            objecttype: item.tipo // preserve original tipo separately
          });
        });
      })
    );

    Promise.all(fetchPromises)
      .then(enrichedObjects => {
        const validObjects = enrichedObjects.filter(item => item !== null);
        setObjects(validObjects.filter(item => item.extra == 0));
        setExtraObjects(validObjects.filter(item => item.extra == 1));
      })
      .catch(error => {
        console.error('Error enriching object data:', error);
      });
  });
}

const prepareItemsForPost = (items) => {
  return items.flatMap(item => {
    if (['Bateria', 'Control'].includes(item.tipo) && item.cantidad > 1) {
      return Array(item.cantidad).fill().map((_, i) => ({
        ...item,
        cantidad: 1,
        no_serie: item.series?.[i] || '',
      }));
    }
    return item;
  });
};
useEffect(() => {
  // Collect all tipos from both new and edited items
  const tiposToFetch = new Set();

  newObjectsToPost.forEach(obj => {
    if (obj.tipo && !fetchedTipos.has(obj.tipo)) tiposToFetch.add(obj.tipo);
  });

  updatedObjects.forEach(obj => {
    if (obj.tipo && !fetchedTipos.has(obj.tipo)) tiposToFetch.add(obj.tipo);
  });

  tiposToFetch.forEach(tipo => {
    fetchData(API_URLS.ACCESORIES + "?tipo=" + tipo, (data) => {
      setAccesories(prev => ({ ...prev, [tipo]: data }));
      setFetchedTipos(prev => new Set(prev).add(tipo));
    });
  });
}, [newObjectsToPost, updatedObjects]);
const renderAddItem = (tipo, index) => {
  const cantidad = newObjectsToPost[index]?.cantidad || 1;
  return (
    <div className="vertical-container"> {/* Cambiado a vertical-container */}
      <div className="invisible-horizontal-container">
        Modelo:
        <DropdownSearch
          
          returnSelectedKey={(key) => updateNewObjectField(index, 'objectid', key)}
          returnSelectedOption={(model) => updateNewObjectField(index, 'modelo', model)}
          keys={(accesories[tipo] ?? []).map(item => item.id)}
          options={(accesories[tipo] ?? []).map(item => item.modelo)}
        />

        Cantidad:
        <input
          type="number"
          min={1}
          value={cantidad}
          max={100}
          onChange={(e) => {
            const val = parseInt(e.target.value);
            if (!isNaN(val)) {
              updateNewObjectField(index, 'cantidad', val);
              updateNewObjectField(index, 'series', Array(val).fill(''));
            }
          }}
        />
      </div>

      <div className="series-container"> {/* Nuevo contenedor para números de serie */}
        {Array(cantidad).fill().map((_, i) => (
          <div key={i} className="invisible-horizontal-container">
            Número de serie {i + 1}:
            <EditText
              defaultText={newObjectsToPost[index]?.series?.[i] || ''}
              onChange={(val) => {
                const updatedSeries = [...(newObjectsToPost[index]?.series || [])];
                updatedSeries[i] = val;
                updateNewObjectField(index, 'series', updatedSeries);
              }}
            />
          </div>
        ))}
      </div>

      <div className="invisible-horizontal-container">
        Observaciones:
        <EditText
          defaultText={newObjectsToPost[index]?.observaciones || ''}
          onChange={(val) => updateNewObjectField(index, 'observaciones', val)}
        />
        
        <button onClick={() => {
          setNewObjectsToPost(prev => prev.filter((_, i) => i !== index));
          setItemsToAdd(prev => prev.filter(it => it !== tipo));
          setTipoToIndexMap(prev => {
            const updated = { ...prev };
            delete updated[tipo];
            return updated;
          });
        }}>
          🗑️
        </button>
      </div>
    </div>
  );
};
useEffect(() => {
  newExtraObjects.forEach((item, index) => {
    if (!item.objecttype || !item.url) return;

    // Fetch tipos
    fetchData(`${item.url}`, (data) => {
      const uniqueTipos = [...new Set(data.map(acc => acc.tipo))];
      setExtraAccesories((prev) => ({
        ...prev,
        [index]: {
          ...prev[index],
          tipoOptions: uniqueTipos,
        },
      }));
    });

    // Fetch modelos only if tipo already selected
    if (item.tipo) {
      fetchData(`${item.url}?tipo=${item.tipo}`, (data) => {
        setExtraAccesories((prev) => ({
          ...prev,
          [index]: {
            ...prev[index],
            modeloOptions: data,
          },
        }));
      });
    }
  });
}, [newExtraObjects]);
const editItem = (item) => {
  const cantidad = updatedObjects.find(obj => obj.id === item.id)?.cantidad || item.cantidad;
  
  return (
    <div className="vertical-container">
      <div className="invisible-horizontal-container">
        Modelo:
        <DropdownSearch
          placeholder={item.modelo}
          returnSelectedKey={(data) => {
            setUpdatedObjects(prev => {
              const updated = [...prev];
              const index = updated.findIndex(obj => obj.id === item.id);
              if (index !== -1) {
                updated[index] = { ...updated[index], objectid: data };
              }
              return updated;
            });
          }}
        
          keys={(accesories[item.tipo] ?? []).map(item => item.id)}
          options={(accesories[item.tipo] ?? []).map(item => item.modelo)}
        />

        Cantidad:
        <input
          type="number"
          min={1}
          value={cantidad}
          max={100}
          onChange={(e) => {
            const value = e.target.value;
            if (value.length <= 3 && /^\d*$/.test(value)) {
              const numericValue = parseInt(value, 10);
              setUpdatedObjects(prev => {
                const updated = [...prev];
                const index = updated.findIndex(obj => obj.id === item.id);
                if (index !== -1) {
                  updated[index] = {
                    ...updated[index],
                    cantidad: isNaN(numericValue) ? 0 : numericValue,
                    series: Array(numericValue).fill().map((_, i) => 
                      updated[index]?.series?.[i] || item.series?.[i] || ''
                    )
                  };
                }
                return updated;
              });
            }
          }}
        />
      </div>

      

      <div className="invisible-horizontal-container">
        Observaciones:
        <EditText
          defaultText={item.observaciones}
          onChange={(data) => {

            setUpdatedObjects(prev => {
              const updated = [...prev];
              const index = updated.findIndex(obj => obj.id === item.id);
              if (index !== -1) {
                updated[index] = { ...updated[index], observaciones: data };
              }
              return updated;
            });
          }}
        />
      </div>

    </div>
  );
};

    return(

      <Popup title='Ver nota de recepcion' onClose={onClose}>
        <div className="invisible-horizontal-container">

          Cliente: {`${clientData?.nombre || ''} ${clientData?.apellidos || ''}`}

        </div>
        <div className="invisible-horizontal-container">
          <div>
            Folio: {generateFolio(clientData?.id, claimData.fecha, claimData.sucursal)} 
          </div>
          

        </div>
        <div className="two-column-text">
  {Object.entries(claimData).map(([key, value]) => (
    <div key={key} className="invisible-horizontal-container">
      {key.charAt(0).toUpperCase() + key.slice(1)}: {value}
    </div>
  ))}
</div>
        <div className="header1">Dron</div>
        <div className="invisible-horizontal-container">
          {objects && objects.filter(item => item.objecttype === "Dron Enterprise" || item.objecttype === "Dron Comercial").map((item, index) => (
            <div className="invisible-horizontal-container" key={index}>
              <div>Serie: {item.serie}</div>
              <div>Modelo: {item.modelo}</div>
              {updatedDrone ? (
                <div className="invisible-horizontal-container">
                No. serie:
                <EditText onChange={(data)=>{setUpdatedDrone({...updatedDrone,no_serie:data})}} defaultText={item.no_serie}></EditText>
                Observaciones:
                <EditText onChange={(data)=>{setUpdatedDrone({...updatedDrone,observaciones:data})}} defaultText={item.observaciones}></EditText>
                </div>
              ):(
                <div className="invisible-horizontal-container"><div>No. serie: {item.no_serie}</div>
                  <div>Observaciones: {item.observaciones}</div>
                  <Button onClick={()=>setUpdatedDrone(item)}text="✏️"></Button>
                </div>
              )}
              
            </div>
            ))} 
        </div>
        {objects && tipos.map((tipo) => {
          const items = objects.filter(item => item.tipo === tipo);
          return (
            <div key={tipo}>
              <div className="header1">{tipo}</div>
              {items.length > 0 ? (
                items.map((item) => (
                  <div className="invisible-horizontal-container" key={item.id}>
                    {itemsToAdd.includes(item) ? (
                      editItem(item)
                    ) : (
                      <>
                        <div>Modelo: {item.modelo}</div>
                        <div>No. serie: {item.no_serie}</div>
                        <div>Observaciones: {item.observaciones}</div>
                        <button
                          onClick={() => {
                            setItemsToAdd([...itemsToAdd, item]);
                            ensureItemInUpdatedObjects(item);
                          }}
                        >
                          ✏️
                        </button>
                      </>
                    )}
                    <button
                      onClick={() => {
                        setObjectsToDelete((prev) => [...prev, item.id]);
                        setObjects((prev) => prev.filter((obj) => obj.id !== item.id));
                      }}
                    >
                      🗑️
                    </button>
                  </div>
                ))
              ) : (
                <div>
                  {itemsToAdd.includes(tipo) && tipoToIndexMap[tipo] !== undefined ? (
                    renderAddItem(tipo, tipoToIndexMap[tipo])
                  ) : (
                    <Button
                      text={"Agregar " + tipo}
                      onClick={() => {
                        handleAddClick(tipo);
                      }}
                    />
                  )}
                </div>
              )}
            </div>
          );
        })}

        <div className="invisible-horizontal-container">
          <div className="header1">ExtraItems</div>
          <button onClick={()=>setNewExtraObjects([...newExtraObjects,{extra:1,cantidad:1,observaciones:"", no_serie:""}])}>➕</button>
        </div>
        
        <div style={{ display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
          flexGrow: 1,
          minHeight: 'fit-content',}}>
        { extraObjects && extraObjects.map((item,index)=>{
          return(
          
          <div className="invisible-horizontal-container" style={{ marginBottom: '1rem', paddingBottom: '1rem', borderBottom: '1px solid #ddd' }} >
            <div>Tipo de objeto: {item.objecttype}</div>
            <div>Tipo de {item.objecttype}: {item.tipo}</div>
            <div>Modelo: {item.modelo}</div>
            <div>No. serie: {item.no_serie}</div>
            <div>Observaciones: {item.observaciones}</div>
            <button onClick={()=>{setObjectsToDelete(prev => [...prev, item.id]);;setExtraObjects(prev => prev.filter((_, i) => i !== index));}}>🗑️</button>
          </div>
          )
        })}
        {newExtraObjects && newExtraObjects.map((item,index)=>{
          return(
            <div>
              <div key={index} style={{ marginBottom: '1rem', paddingBottom: '1rem', borderBottom: '1px solid #ddd' }}>
                <div className="invisible-horizontal-container">
                Tipo de objeto:
                <Dropdown placeholder="Selecciona..." returnSelectedOption={(value)=>{
                  setExtraAccesories((prev) => ({...prev,[index]: { tipoOptions: [], modeloOptions: [] } }));
                  updateNewExtraObject(index,'objecttype',value);
                  var url;
                  switch(value){
                    case 'Accesorio':
                      url = API_URLS.ACCESORIES
                      break;
                    case 'Parte':
                      url = API_URLS.PARTS
                      break
                  }
                  updateNewExtraObject(index,'url',url)
                }}
                  options={['Accesorio','Parte']}></Dropdown>
                {item['objecttype'] &&(
                  <div>
                  <div >
                    Tipo de {item['objecttype']}:
                    <DropdownSearch 
                        returnSelectedOption={(selectedTipo) => {
                        updateNewExtraObject(index, 'tipo', selectedTipo);
                        setExtraAccesories((prev) => ({
                          ...prev,
                          [index]: {
                            ...prev[index],
                            modeloOptions: []
                          }
                        }));
                    }} options={extraAccesories[index]?.tipoOptions ?? []}
                      ></DropdownSearch>
                    Modelo:
                    <DropdownSearch 

                    returnSelectedKey={(selectedModelo) => {
                      updateNewExtraObject(index, 'objectid', selectedModelo);
                    }}
                    keys={(extraAccesories[index]?.modeloOptions ?? []).map(i=>i.id)}
                    options={(extraAccesories[index]?.modeloOptions ?? []).map(i=>i.modelo)}
                      ></DropdownSearch>
                Cantidad:
                <input
                  type="number"
                  min={1}
                  defaultValue={1}
                  max={100}
                  // value={currentObject.cantidad || ''}
                  onChange={(data) => {
                    const value = data.target.value;
                    // Limitar a 3 caracteres y solo números
                    if (value.length <= 3 && /^\d*$/.test(value)) {
                      const numericValue = parseInt(value, 10);
                      // Asegurarse de que el valor esté dentro del rango permitido
                      if (!isNaN(numericValue) && numericValue >= 1 && numericValue <= 100) {
                        updateNewExtraObject(index,'cantidad',numericValue);
                      } else if (value === '') {
                        updateNewExtraObject(index,'cantidad',0);
                      }
                  }
                  }}
                />
                </div>
                <div className="invisible-horizontal-container">
                Numero de serie:
                <EditText onChange={(data)=>{
                  updateNewExtraObject(index,'no_serie',data);
                }}defaultText={item.no_serie}></EditText>
                Observaciones:
                <EditText onChange={(data)=>{
                  updateNewExtraObject(index,'observaciones',data);
                }}defaultText={item.observaciones}></EditText>
                  </div>
                  </div>
                )}
                <button onClick={()=>{setNewExtraObjects(prev => prev.filter((_, i) => i !== index));}}>🗑️</button>
                </div>
                
              </div>
            </div>
        )})}
        </div>

        {(objectsToDelete.length>0 || updatedObjects.length>0 || updatedDrone || newExtraObjects.length>0 || newObjectsToPost.length>0) && (
          <Button text="Guardar cambios" onClick={async () => {
          try {
            // DELETE
            const deletePromises = objectsToDelete.map(item =>
              deleteData(API_URLS.CLAIMOBJECT + "?id=" + item)
            );

            // PUT
            console.log(updatedObjects);
            const putPromises = [...updatedObjects, updatedDrone]
              .filter(item => item && item !== false && item.id !== undefined && item.id !== null)
              .map(item =>
                putData(API_URLS.CLAIMOBJECT, {
                  ...item,
                  tipo: item.objecttype
                })
            );

            console.log(updatedDrone)
            
    // POST extra objects
    console.log(newExtraObjects);
    const postExtraPromises = newExtraObjects.map(item =>
      postData(API_URLS.CLAIMOBJECT, {
        ...item,
        tipo: item.objecttype,
        NotasRecepcion_folio: claimData.id,
        extra: 1,
        custom_product_name: ""
      })
    );
    
    // POST new objects
    console.log(newObjectsToPost);

    const postNewPromises = prepareItemsForPost(newObjectsToPost).map(item =>

      postData(API_URLS.CLAIMOBJECT, {
        ...item,
        tipo: "Accesorio",
        NotasRecepcion_folio: claimData.id,
        extra: 0,
        custom_product_name: ""
      })
    );

    // Wait for all of them to finish
    await Promise.all([
      ...deletePromises,
      ...putPromises,
      ...postExtraPromises,
      ...postNewPromises
    ]);

    // ✅ Final callback
    console.log("✅ All operations completed");
    fetchObjects()
    // onAllOperationsDone();

  } catch (error) {
    console.error("❌ Error during saving operations:", error);
  }
}} />
        )}

        <div className="justify-right">
          {canRead('acceso_notas_recepcion') && (
            <Button
            text={"DESCARGAR NOTA"}
            color={"#7AACE3"}
            onClick={() => {
              downloadNotePDF(claimData.id, claimData.fecha, claimData.cliente)
              
            }}
            />
          )}
        </div>

        

      </Popup>
    )
}
export default ViewClaim;